import { render, staticRenderFns } from "./Volume.vue?vue&type=template&id=afcc5112&lang=pug&"
import script from "./Volume.vue?vue&type=script&lang=ts&"
export * from "./Volume.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports